@for (component of components | async; track component.component) {
  <ng-container *ngComponentOutlet="component.component; injector: component.injector" />
}
